import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sandra Dellolio',
      role: 'Atlantic Toyota',
      avatar: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/4ebe1f23e3103b2d68287d2bc0923c97.png',
      quote: 'Great personal attention to his clients. Works one on one to make your projects exactly what you want. Social media and reputation management expert.',
      metric: '5.0',
      metricLabel: 'Google Rating'
    },
    {
      id: 2,
      name: 'Liz Farrell',
      role: 'Paul Gold Real Estate Inc.',
      avatar: 'https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/6825839fc7fb78bb68bdcee8b4fe8906.jpeg',
      quote: 'Bellport Branding is assisting me to in getting my Real Estate business up and running. They have helped me with knowledge education, and execution of both branding and social media. They are extremely patient, and available to answer even the simplest questions. I highly recommend!',
      metric: '5.0',
      metricLabel: 'Google Rating'
    },
    {
      id: 3,
      name: 'Steve Toomey',
      role: 'Atlantic Cadillac',
      avatar: null,
      quote: 'I have worked with Bellport Branding for years. Always professional, creative, and efficient. I\'ve recommend them many of my colleagues.',
      metric: '5.0',
      metricLabel: 'Google Rating'
    }
  ];

  return (
    <section id="testimonials" className="py-32 bg-neutral-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-sm font-medium text-[#1E3A8A] tracking-wide mb-4">
            CLIENT SUCCESS
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-neutral-900 tracking-tight">
            Trusted by leaders
          </h2>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-700 ease-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {testimonials.map((testimonial) => (
                <div
                  key={testimonial.id}
                  className="w-full flex-shrink-0 px-4"
                >
                  <div className="bg-white rounded-3xl p-10 md:p-14 text-center">
                    <div className="w-16 h-16 rounded-full overflow-hidden mx-auto mb-8 bg-[#1E3A8A]/10 flex items-center justify-center">
                      {testimonial.avatar ? (
                        <img
                          src={testimonial.avatar}
                          alt={testimonial.name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <i className="ri-user-line text-[#1E3A8A] text-2xl"></i>
                      )}
                    </div>

                    <p className="text-xl md:text-2xl text-neutral-700 leading-relaxed mb-8 font-light">
                      "{testimonial.quote}"
                    </p>

                    <div className="mb-8">
                      <span className="text-4xl font-semibold text-[#1E3A8A]">
                        {testimonial.metric}
                      </span>
                      <p className="text-sm text-neutral-500 mt-1">
                        {testimonial.metricLabel}
                      </p>
                    </div>

                    <div>
                      <p className="font-semibold text-neutral-900">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-neutral-500">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-10">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'bg-neutral-900 w-6' : 'bg-neutral-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}